import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d760588c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "introduce",
  class: "introduce"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography = _resolveComponent("a-typography")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_a_typography, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_typography_title, { level: 2 }, {
          default: _withCtx(() => [
            _createTextVNode(" 星汉未来(Galaxy-Future) ")
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_a_typography_paragraph, null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.textList, (item, index) => {
          return (_openBlock(), _createElementBlock("p", { key: index }, " >" + _toDisplayString(item), 1 /* TEXT */))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    })
  ]))
}